import { createSlice } from "@reduxjs/toolkit";
const initialState =
{
  A_VocTyp: ""
  , A_VocTypName: ""
  , A_VocNo: "0"
  , A_PostDt: new Date()  // dd/MM/yyyy
  , A_RefDt: new Date() // dd/MM/yyyy
  , A_RefNo: ""
  , A_Party: ""
  , A_PartyName: ""
  , A_Curr: ""
  , A_Currname: ""
  , A_ExRate: 1// Decimal
  , A_PayMode: "CREDIT"
  , A_Type: "LOCAL"
  , A_Br: ""   //LocationBrCode
  , A_BrName:""  //location branchName
  , A_Loc: ""
  , A_LocName: ""
  , A_Buyer: ""
  , A_Buyername: ""
  , A_Narr: ""
  , A_CrAc: ""
  , A_CrAcName: ""
  , A_DrAc: ""
  , A_DrAcName: ""
  , A_GrossAmt: 0 //decimal
  , A_DiscPerc: 0 //decimal
  , A_DiscAmt: 0 //decimal
  , A_DiscFlag: "N"
  , A_Rounding: 0 //decimal
  , A_TaxAmt: 0 //decimal
  , A_NetAmt: 0 //decimal
  , A_LC: 0 //decimal
  , A_Charges1: 0 //decimal
  , A_Charges2: 0 //decimal
  , A_DocStat: "ENTER"
  , A_CUSTFIELD3: "INTRN001"    //tax  ->      // INTRN001->VAT		INTRN002->INTER COMPANY  INTRN002->IMPORT
  , A_CUSTFIELD3Name: ""
  , A_CUSTFIELD4: "N"
  , A_CUSTFIELD5: ""          // Unloading Bin ID
  , A_CUSTFIELD5Name: ""      // Unloading Bin Name
  , A_CUSTFIELD6: "VENDOR_INV"          // From     // VENDOR_INV->Vendor		TRANSFER_RETURN->Outlet		SALES_RETURN ->Sales Return
  , A_CUSTFIELD8: ""
  , A_CUSTFIELD9: ""
  , A_ExciseTaxNetAmt: 0 //Decimal
  , A_TaxGross: "N"
  , A_Taxable: "Y"
  , A_ScaleItm: "N"
  , A_TCS: 0//Decimal
  , Source: ""
  , A_RefDocTyp: ""
  , A_RefDocTypName: ""
  , A_RefDocNo: ""
  , A_RefDocVer: 0 //Int
  , A_RefNo4 :0 //INvoice Amount
  ,A_CUSTFIELD7: "N" // Offer Y/N

};

const SliceGRNHead = createSlice({
  name: "SliceGRNHead",
  initialState: { value: initialState },

  reducers: {
    GrnHead_Set: (state, action) => {
      state.value = action.payload;
    },

    GrnHead_Init: (state) => {
      state.value = initialState;
    },
    // GrnHead_ResetValue: (state,action) => {  
    //   state.value.A_VocNo=action.payload.A_VocNo;
    //   state.value.A_RefNo=action.payload.A_RefNo;
    // },
    GrnHead_SetValueLoc: (state, action) => {
      state.value.A_Loc = action.payload.A_Loc;
      state.value.A_LocName = action.payload.A_LocName;
      state.value.A_Br = action.payload.A_Br;
      state.value.A_BrName = action.payload.A_BrName;
    },
    GrnHead_SetValueVendor: (state, action) => {
      state.value.A_Party = action.payload.A_Party;
      state.value.A_PartyName = action.payload.A_PartyName;
    },
    GrnHead_SetValue_GRN_Type: (state, action) => {
      state.value.A_VocTyp = action.payload.A_VocTyp;
      state.value.A_VocTypName = action.payload.A_VocTypName;
    },
    GrnHead_SetValue_Unloading: (state, action) => {
      state.value.A_CUSTFIELD5 = action.payload.A_CUSTFIELD5;
      state.value.A_CUSTFIELD5Name = action.payload.A_CUSTFIELD5Name;
    },
    GrnHead_SetValue_Form: (state, action) => {
      state.value.A_CUSTFIELD6 = action.payload.A_CUSTFIELD6;
    },
    GrnHead_SetValue_Paymode: (state, action) => {
      state.value.A_PayMode = action.payload.A_PayMode;
    },
    GrnHead_SetValue_Currency: (state, action) => {
      state.value.A_Curr = action.payload.A_Curr;
      state.value.A_Currname = action.payload.A_Currname;
      state.value.A_ExRate = action.payload.A_ExRate;
    },
    GrnHead_SetValue_Tax: (state, action) => {
      state.value.A_CUSTFIELD3 = action.payload.A_CUSTFIELD3;
    },
    GrnHead_SetValue_Offer: (state, action) => {
      state.value.A_CUSTFIELD7 = action.payload.A_CUSTFIELD7;
    },
    GrnHead_SetValue_RefDoc: (state, action) => {
      state.value.A_RefDocTyp = action.payload.A_RefDocTyp;
      state.value.A_RefDocTypName = action.payload.A_RefDocTypName;
    },
    GrnHead_SetValue_RefDocNo: (state, action) => {
      state.value.A_RefDocNo = action.payload.A_RefDocNo;
    },
    GrnHead_SetValue_GrnNo: (state, action) => {
      state.value.A_VocNo = action.payload.A_VocNo;
    },
    GrnHead_SetValue_GrnDate: (state, action) => {
      state.value.A_PostDt = action.payload.A_PostDt;
    },
    GrnHead_SetValue_InvDate: (state, action) => {
      state.value.A_RefDt = action.payload.A_RefDt;
    },
    GrnHead_SetValue_RefDocVer: (state, action) => {
      state.value.A_RefDocVer = action.payload.A_RefDocVer;
    },
    GrnHead_SetValue_InvNo: (state, action) => {
      state.value.A_RefNo = action.payload.A_RefNo;
    },
    GrnHead_SetValue_InvAmt: (state, action) => {
      state.value.A_RefNo4 = action.payload.A_RefNo4;
    },
    GrnHead_SetValue_SrcDocNo: (state, action) => {
      state.value.A_RefDocTyp = action.payload.A_RefDocTyp;
      state.value.A_RefDocTypName = action.payload.A_RefDocTypName;
      state.value.A_RefDocNo = action.payload.A_RefDocNo;
      state.value.A_Party = action.payload.A_Party;
      state.value.A_PartyName = action.payload.A_PartyName;
      state.value.A_CUSTFIELD6 = action.payload.A_CUSTFIELD6;
      state.value.A_CUSTFIELD5 = action.payload.A_CUSTFIELD5;
      state.value.A_CUSTFIELD5Name = action.payload.A_CUSTFIELD5Name;
      state.value.A_PostDt = action.payload.A_PostDt;
      state.value.A_RefNo = action.payload.A_RefNo;
      state.value.A_RefDt = action.payload.A_RefDt;
      state.value.A_RefNo4= action.payload.A_RefNo4;
      state.value.A_RefDocVer= action.payload.A_RefDocVer;
    },
    GrnHead_SetValue_SrcDocNo_Init: (state, action) => {
      state.value.A_RefDocTyp = initialState.A_RefDocTyp;
      state.value.A_RefDocTypName = initialState.A_RefDocTypName;
      state.value.A_RefDocNo = initialState.A_RefDocNo;
      state.value.A_Party = initialState.A_Party;
      state.value.A_PartyName = initialState.A_PartyName;
      state.value.A_CUSTFIELD6 = initialState.A_CUSTFIELD6;
      state.value.A_CUSTFIELD5 = initialState.A_CUSTFIELD5;
      state.value.A_CUSTFIELD5Name = initialState.A_CUSTFIELD5Name;
      state.value.A_PostDt = initialState.A_PostDt;
      state.value.A_RefNo = initialState.A_RefNo;
      state.value.A_RefDt = initialState.A_RefDt;
      state.value.A_RefNo4= initialState.A_RefNo4;
      state.value.A_RefDocVer= initialState.A_RefDocVer;
    }
  },
});

export const {
  GrnHead_Set,
  GrnHead_Init,
  GrnHead_ResetValue, //new btn
  GrnHead_SetValueLoc,
  GrnHead_SetValueVendor,
  GrnHead_SetValue_GRN_Type,
  GrnHead_SetValue_Unloading,
  GrnHead_SetValue_Form,
  GrnHead_SetValue_Paymode,
  GrnHead_SetValue_Currency,
  GrnHead_SetValue_Tax,
  GrnHead_SetValue_Offer,
  GrnHead_SetValue_RefDoc,
  GrnHead_SetValue_RefDocNo,
  GrnHead_SetValue_GrnNo,
  GrnHead_SetValue_GrnDate,
  GrnHead_SetValue_InvDate,
  GrnHead_SetValue_RefDocVer,
  GrnHead_SetValue_InvNo,
  GrnHead_SetValue_InvAmt,
  GrnHead_SetValue_SrcDocNo,
  GrnHead_SetValue_SrcDocNo_Init
} = SliceGRNHead.actions;
export default SliceGRNHead.reducer;
